export default __webpack_public_path__ + "static/stonework-b777957b9b7b560947216190f30287ae.webp";